import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "Produk", href: "#katalog" },
  { label: "Brand", href: "#brand" },
  { label: "Tentang", href: "#manifesto" },
  { label: "Testimoni", href: "#testimoni" },
  { label: "Kontak", href: "#footer" },
];

const Navbar = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo">
          <img src="/winselindo-mark.png" alt="Winselindo" className="h-8 w-auto" />
          <span className="font-display font-black text-2xl tracking-tighter text-white hidden sm:inline">
            WINSELINDO
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-body text-sm text-white/60 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setOpen(true)}
            data-testid="cart-sheet-trigger"
            className="relative flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 hover:bg-white/5 transition-colors"
          >
            <ShoppingBag className="w-4 h-4 text-white" />
            <span className="hidden sm:inline text-sm text-white font-body">Keranjang</span>
            {count > 0 && (
              <span className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-accent-wl text-black text-xs font-bold flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button className="md:hidden text-white" onClick={() => setMobile((m) => !m)} data-testid="mobile-menu-btn">
            {mobile ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMobile(false)} className="font-body text-white/70 hover:text-white">
              {l.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
